import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=56009f50&scoped=true&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=56009f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56009f50",
  null
  
)

export default component.exports